import { Card } from '@components'
import GoBack from '@components/back'
import { cardStyle, StyleCardTitle, StyleColumn } from '@components/styles'
import { useLocation, useParams } from 'react-router-dom'
import AdminOfficeDetailForm from './officeDetail'
import AdminSupportAgentForm from './supportAgent'

const AdminHelpSupportForm = () => {
  const { id, type } = useParams<{ id: string; type: string }>()
  const { state: data } = useLocation()

  return (
    <>
      <StyleColumn>
        <GoBack visibleForDesktop={true} />
        <Card customStyle={cardStyle}>
          <StyleCardTitle>
            {!!id ? 'Update' : 'Add'}{' '}
            {type === 'support-agent' ? ' Support Agent' : 'Office'} Details
          </StyleCardTitle>
          {type === 'support-agent' && (
            <AdminSupportAgentForm supportAgent={data} />
          )}
          {type === 'office-detail' && (
            <AdminOfficeDetailForm officeDetail={data} />
          )}
        </Card>
      </StyleColumn>
    </>
  )
}

export default AdminHelpSupportForm
